import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import WorkSchedulesAPI from '../../api/workSchedules';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getWorkSchedules($state) {
    return $state.records;
  },
  getWorkSchedule: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  // The API answers a bare array, like teams — there is no `payload` wrapper here.
  get: async ({ commit }) => {
    commit(types.SET_WORK_SCHEDULES_UI_FLAG, { isFetching: true });
    try {
      const response = await WorkSchedulesAPI.get();
      commit(types.SET_WORK_SCHEDULES, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_WORK_SCHEDULES_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, workSchedule) => {
    commit(types.SET_WORK_SCHEDULES_UI_FLAG, { isCreating: true });
    try {
      const response = await WorkSchedulesAPI.create({
        work_schedule: workSchedule,
      });
      commit(types.ADD_WORK_SCHEDULE, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WORK_SCHEDULES_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...workSchedule }) => {
    commit(types.SET_WORK_SCHEDULES_UI_FLAG, { isUpdating: true });
    try {
      const response = await WorkSchedulesAPI.update(id, {
        work_schedule: workSchedule,
      });
      commit(types.EDIT_WORK_SCHEDULE, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WORK_SCHEDULES_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_WORK_SCHEDULES_UI_FLAG, { isDeleting: true });
    try {
      await WorkSchedulesAPI.delete(id);
      commit(types.DELETE_WORK_SCHEDULE, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WORK_SCHEDULES_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_WORK_SCHEDULES_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_WORK_SCHEDULES]: MutationHelpers.set,
  [types.ADD_WORK_SCHEDULE]: MutationHelpers.setSingleRecord,
  [types.EDIT_WORK_SCHEDULE]: MutationHelpers.update,
  [types.DELETE_WORK_SCHEDULE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
